import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import Page from '../../common-components/Page';
import FormContainer from '../../common-components/FormContainer';
import AyncLoading from '../../common-components/AyncLoading';
import FlexOne from '../../common-components/FlexOne';
import ComfirmDialog from '../../common-components/ComfirmDialog';
import StationListDialog from '../../stations-mgmt/view/StationListDialog';
import SelectedStationsChips from '../../stations-mgmt/view/SelectedStationsChips';

import * as usersReducer from '../reducer';
import * as userScreenReducer from '../reducer/userScreen';
import * as personasReducer from '../../personas-mgmt/reducer';
import * as stationsReducer from '../../stations-mgmt/reducer';
import * as systemReducer from '../../system/reducer';

import * as userScreenActions from '../action-mgr/userScreen';
import * as personasAction from '../../personas-mgmt/action-creator';
import * as stationsAction from '../../stations-mgmt/action-mgr';
import * as usersAction from '../action-mgr';

import * as strings from '../../helpers/strings';
import { userStatus, roles } from '../constants';

const styles = {
  personaSelect: {
    flex: 1
  }
}

class UserScreen extends Component {

  constructor() {
    super();

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.handleMaxSessionCompanyChange = this.handleMaxSessionCompanyChange.bind(this);
    this.handleMaxSessionClientChange = this.handleMaxSessionClientChange.bind(this);
    this.handleMobileChange = this.handleMobileChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePersonaChange = this.handlePersonaChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleActivate = this.handleActivate.bind(this);
    this.handleDeactivate = this.handleDeactivate.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleAddPersona = this.handleAddPersona.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleSubClientChange = this.handleSubClientChange.bind(this);
    this.handleConfirmDeactivate = this.handleConfirmDeactivate.bind(this);
    this.handleRemoveStation = this.handleRemoveStation.bind(this);
    this.calculateAvaliableSession = this.calculateAvaliableSession.bind(this);

    this.handleCallUsers = this.handleCallUsers.bind(this);

    this.state = {
      subClient: false,
      maxSession: 0,
      maxLimitClient: 999,
      maxLimitSubClient: 999,
      availableSession: 0,
      role: 'role',
      totalSubClientSession: 0,
      errorSubClient: '',
      errorClient: '',
      subClientUser: "-1",
      newUser: false,
      defaultUserData: null,
    };

  }

  componentDidMount() {
    const { personas, fetchAllPersonas, user, loggedInUser, resetActionStatus, users } = this.props;

    this.setState({ defaultUserData: user })

    if (loggedInUser === "system-user" && user.name === "") {
      this.setState({ newUser: true })
    }

    if (user.parentId) {

      let totalCompanySession = 0;  // Company Session
      let totalclientSession = 0;      // Client Session
      let totalSubSession = 0;      // Total SubClient Session

      users.forEach(usr => {
        if (usr.id === user.parentId) {
          totalCompanySession = usr.maxSession
          totalclientSession = usr.maxSessionIndividual
        } else if (usr.id === user.id) {
          totalSubSession += usr.maxSession
        } else {
          if (usr.parentId === user.parentId) {
            totalclientSession += usr.maxSession
          }
        }
      })

      this.setState({
        maxSession: totalCompanySession - (totalclientSession + totalSubSession)
      })

    } else {

      let totalCompanySession = 0;  // Company Session
      let totalclientSession = 0;      // Client Session
      let totalSubSession = 0;      // Total SubClient Session

      users.forEach(usr => {
        if (usr.id === user.id) {
          totalCompanySession = usr.maxSession
          totalclientSession = usr.maxSessionIndividual
        } else if (usr.parentId === user.id) {
          totalSubSession += usr.maxSession
        }
      })
      this.setState({
        maxSession: totalCompanySession - (totalclientSession + totalSubSession)
      })
    }

    if (user.id) {
      let totalclientSession = 0;
      users.forEach(usr => {
        if (usr.parentId === user.id) {
          totalclientSession += usr.maxSession
        }
      })
      this.setState({
        maxLimitClient: user.maxSession - totalclientSession
      })
    }

    if (user.parentId !== null) {

      let totalCompanySession = 0;  // Company Session
      let totalclientSession = 0;      // Client Session
      let totalOtherSubSession = 0;      // Total SubClient Session

      users.forEach(usr => {
        if (usr.id === user.parentId) {
          totalCompanySession = usr.maxSession
          totalclientSession = usr.maxSessionIndividual
        } else if (usr.id === user.id && user.id !== usr.id) {
          totalOtherSubSession += usr.maxSession
        }
      })

      this.setState({
        maxLimitSubClient: totalCompanySession - (totalclientSession + totalOtherSubSession)
      })
    }

    resetActionStatus();

    if (!personas.length)
      fetchAllPersonas();

    this.setState({
      role: user.role
    })

    if (loggedInUser.role === "system-user") {
      this.props.setRole("autoAdded")
      this.props.setCompany("autoAdded")
    }


    if (!user.parentId && user.role === "sub-system-user") {

      this.setState({
        subClient: true,
        maxSession: 9999,
        maxLimitSubClient: 9999
      })
    }


  }

  componentDidUpdate() {
    const { actionStatus, history, clearStationSelections } = this.props;
    if (actionStatus === true) {
      history.push("/users");
      clearStationSelections();
    }
  }

  handleNameChange(e) {
    this.props.setName(e.target.value);
  }

  handleEmailChange(e) {
    this.props.setEmail(e.target.value);
  }

  handleCompanyChange(e) {
    this.props.setCompany(e.target.value);
  }

  handleMobileChange(e) {
    this.props.setMobile(e.target.value);
  }

  handleMaxSessionCompanyChange(e) {
    this.props.setMaxSessionCompany(e.target.value);
  }

  handleMaxSessionClientChange(e) {
    this.props.setMaxSessionClient(e.target.value);
  }

  handlePhoneChange(e) {
    this.props.setPhone(e.target.value);
  }

  handlePasswordChange(e) {
    this.props.setPassword(e.target.value);
  }

  handlePersonaChange(event) {
    this.props.setPersonaId(event.target.value);
  }

  handleSave() {
    const { user, createUser, updateUser, selectedUserId, stations, loggedInUser } = this.props;
    if (this.props.loggedInUser.role === "system-user") {
      user.company = loggedInUser.company;
      user.personaId = loggedInUser.personaId;
      user.parentId = (loggedInUser.id === "") ? null : loggedInUser.id;
      user.role = "sub-system-user";
    }

    const userData = {
      ...user,
      stationList: stations
    }

    if (user.role === "system-user" && user.maxSessionIndividual === null) {
      user.maxSessionIndividual = 1
    }


    const leftSession = document.getElementById("leftSession").getAttribute("data-val")

    if (userData.role === "sub-system-user" && (userData.maxSession > (this.state.defaultUserData.maxSession + this.state.maxSession)) && this.state.defaultUserData.parentId === userData.parentId && parseInt(leftSession) === 0) {
      // *** [Admin Account] System-sub-user (CREATE + EDIT)
      this.setState({
        errorSubClient: "Over Max Allowed Session"
      })
      setTimeout(() => {
        this.setState({
          errorSubClient: ""
        })
      }, 10000)
    } else if (userData.role === "sub-system-user" && (userData.maxSession > this.state.maxLimitSubClient) && this.state.defaultUserData.parentId !== user.parentId && parseInt(leftSession) === 0) {
      // *** [Admin Account] System-sub-user (CREATE + EDIT)
      this.setState({
        errorSubClient: "Over Max Allowed Session"
      })
      setTimeout(() => {
        this.setState({
          errorSubClient: ""
        })
      }, 10000)
    } else if (userData.role === "system-user" && (userData.maxSessionIndividual > userData.maxSession) && parseInt(leftSession) === 0) {
      // *** [Admin Account] System-user (CREATE + EDIT)
      this.setState({
        errorClient: "Over Max Allowed Session"
      })
      setTimeout(() => {
        this.setState({
          errorClient: ""
        })
      }, 10000)
      // } else if (userData.role === "sub-system-user" && (userData.maxSession > (this.state.defaultUserData.maxSession + this.state.maxSession)) && parseInt(leftSession) === 0) {
      //   this.setState({
      //     errorSubClient: "Over Max Allowed Session"
      //   })
      //   setTimeout(() => {
      //     this.setState({
      //       errorSubClient: ""
      //     })
      //   }, 10000)
    } else if (userData.role === "sub-system-user" && (userData.maxSession > (parseInt(leftSession) + this.state.defaultUserData.maxSession)) && parseInt(leftSession) > 0) {
      this.setState({
        errorSubClient: "Over Max Allowed Session"
      })
      setTimeout(() => {
        this.setState({
          errorSubClient: ""
        })
      }, 10000)
    } else {
      if (selectedUserId) {
        updateUser(userData);
      } else {
        createUser(userData);
      }
    }
  }

  handleActivate() {
    const { selectedUserId, activateUser } = this.props;
    activateUser(selectedUserId);
  }

  handleDeactivate() {
    this.props.toggleDeleteConfirm();
  }

  handleConfirmDeactivate() {
    const { selectedUserId, deactivateUser } = this.props;
    deactivateUser(selectedUserId);
  }

  handleBack() {
    const { clearStationSelections, history } = this.props;
    history.push("/users");
    clearStationSelections();
  }

  handleAddPersona() {
    var personaName = prompt("Please enter persona name", "New persona");
    this.props.createPersona(personaName);
  }

  handleRoleChange(event) {
    const { search } = this.props;
    this.props.setRole(event.target.value);
    if (event.target.value === 'sub-system-user') {
      search({
        keyword: '',
        startIndex: "0",
        size: "500",
        status: 1
      });
      this.setState({ subClient: true, maxSession: 999 });
    } else {
      this.props.setSubClient(null);
      this.setState({
        subClient: false,
        maxLimitSubClient: 999,
      });
    }

    this.props.setMaxSessionClient(null);

  }

  handleSubClientChange(event) {
    const { users, subClientSearch } = this.props;

    this.props.setSubClient((event.target.value < 0) ? null : event.target.value);
    this.setState({ subClientUser: (parseInt(event.target.value, 10) < 0) ? "-1" : event.target.value, })

    const selectedUser = users.find(user => user.id === event.target.value)

    if (event.target.value < 0) {

      if (selectedUser) {
        this.calculateAvaliableSession(selectedUser)
      }

      this.setState({
        subClient: true,
        maxSession: 9999,
        maxLimitSubClient: 9999
      })

    } else {
      subClientSearch(selectedUser.company).then(result => {
        if (selectedUser) {
          this.calculateAvaliableSession(selectedUser)
        }
      })
    }
  }

  handleCallUsers() {
    const { search } = this.props;

    search({
      keyword: '',
      startIndex: "0",
      size: "500",
      status: 1
    });

  }

  calculateAvaliableSession(selectedUser) {
    const { users } = this.props;

    let totalCompanySession = 0;  // Company Session
    let totalclientSession = 0;      // Client Session
    let totalSubSession = 0;      // Total SubClient Session

    users.forEach(usr => {

      if (usr.id === selectedUser.id) {
        totalCompanySession = usr.maxSession
        totalclientSession = usr.maxSessionIndividual
      } else if (usr.parentId === selectedUser.id) {
        totalSubSession += usr.maxSession
      }
    })

    this.setState({
      subClient: true,
      maxSession: totalCompanySession - (totalclientSession + totalSubSession),
      maxLimitSubClient: totalCompanySession - (totalclientSession + totalSubSession)
    })
  }

  handleRemoveStation = index => e => {
    this.props.removeStationFromSelections(index);
  }

  render() {
    const { personas, selectedUserId, user, users, nameError, emailError, companyError, mobileError, isValid, isSavingUser, isDeactivatingUser, isActivatingUser, snackBarMessage, isPersonaSaving, toggleDeleteConfirm, openDeleteConfirmation, openStationsDialog, toggleStationsDialog, openedSnackBar, closeSnackBar, loggedInUser,
      maxSessionCompanyError, maxSessionClientError } = this.props;

    let max_company_session = 0;
    let left_session = 0;


    if (loggedInUser.role === "system-user" && users.length > 0) {
      max_company_session = users[0].maxSession;

      users.map(usr => {
        if (usr.parentId !== null && usr.parentId !== "") {
          left_session += usr.maxSession
        } else {
          left_session += usr.maxSessionIndividual
        }
      })
      left_session = max_company_session - left_session
    }

    var isInAyncProcess = isSavingUser || isDeactivatingUser || isActivatingUser;

    var asyncLoadingMessage = "";
    if (isSavingUser || isPersonaSaving)
      asyncLoadingMessage = strings.lblSaving;
    if (isDeactivatingUser)
      asyncLoadingMessage = strings.lblDeactivating;
    if (isActivatingUser)
      asyncLoadingMessage = strings.lblActivating;;

    return (
      <Page title={selectedUserId ? strings.lblEditUser : strings.lblNewUser}>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={openedSnackBar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackBarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        {isInAyncProcess && <AyncLoading message={asyncLoadingMessage} />}
        <Paper style={{ padding: 10 }}>
          <FormContainer>
            <Typography variant="h6">{strings.lblUserInformation}</Typography><br />
            <Grid container spacing={16}>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label={strings.lblName}
                  value={user.name}
                  error={!!nameError}
                  helperText={nameError}
                  onChange={this.handleNameChange}
                  fullWidth={true}
                  variant={strings.txtOutlined}
                  disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                  required
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label={strings.lblEmail}
                  value={user.email}
                  error={!!emailError}
                  helperText={emailError}
                  type="email"
                  fullWidth={true}
                  onChange={this.handleEmailChange}
                  variant={strings.txtOutlined}
                  disabled={!!selectedUserId}
                  required
                />
              </Grid>

              {loggedInUser.role !== "system-user" ?
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    label={strings.lblCompany}
                    value={user.company}
                    error={!!companyError}
                    helperText={companyError}
                    type="text"
                    fullWidth={true}
                    onChange={this.handleCompanyChange}
                    variant={strings.txtOutlined}
                    disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                    required
                  />
                </Grid>
                : ''
              }
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label={strings.lblMobile}
                  value={user.mobile}
                  error={!!mobileError}
                  helperText={mobileError}
                  type="tel"
                  fullWidth={true}
                  onChange={this.handleMobileChange}
                  variant={strings.txtOutlined}
                  disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                  required
                />
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label={strings.lblPhone}
                  value={user.phone}
                  type="tel"
                  fullWidth={true}
                  onChange={this.handlePhoneChange}
                  disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                  variant={strings.txtOutlined}
                />
              </Grid>
              {loggedInUser.role !== "system-user" ?
                <Grid item md={3} sm={6} xs={12}>
                  <Grid container alignItems="center" wrap="nowrap">
                    <FormControl variant={strings.txtOutlined} fullWidth={true}>
                      <InputLabel htmlFor={strings.idSelectPersona}>{strings.lblPersona}</InputLabel>
                      <Select
                        disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                        value={user.personaId || ""}
                        onChange={this.handlePersonaChange}
                        input={
                          <OutlinedInput
                            labelWidth={60}
                            name={strings.lblPersona}
                            id={strings.idSelectPersona}
                          />
                        }
                      >
                        {personas.map(persona =>
                          <MenuItem key={persona.id} value={persona.id}>{persona.name}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    <IconButton
                      disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                      onClick={this.handleAddPersona}>
                      <AddIcon />
                    </IconButton>
                  </Grid>
                </Grid>
                : ''
              }
              {(loggedInUser.role !== "system-user" && this.state.role !== "admin") ?
                <Grid item md={3} sm={6} xs={12}>
                  <FormControl variant={strings.txtOutlined} fullWidth={true} required>
                    <InputLabel htmlFor={strings.idSelectRole} required>{strings.lblRole}</InputLabel>
                    <Select
                      disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                      value={user.role}
                      onChange={this.handleRoleChange}
                      input={
                        <OutlinedInput
                          labelWidth={45}
                          name={strings.lblRole}
                          id={strings.idSelectRole}
                        />
                      }
                    >
                      {roles.map(role => {
                        return ((!!selectedUserId) && (role.value === "admin")) ? false : <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                      }
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                : ''
              }
              {((this.state.subClient || user.role === "sub-system-user") && (loggedInUser.role !== "system-user")) ?
                <Grid item md={3} sm={6} xs={12}>
                  <FormControl variant={strings.txtOutlined} fullWidth={true} required>
                    <InputLabel htmlFor={strings.idSelectRole} required>Client</InputLabel>
                    <Select
                      disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                      value={(user.parentId !== null) ? user.parentId : -1}
                      onChange={this.handleSubClientChange}
                      onClick={this.handleCallUsers}
                      input={
                        <OutlinedInput
                          labelWidth={45}
                          name={strings.lblRole}
                          id={strings.idSelectRole}
                        />
                      }
                    >
                      <MenuItem key={0} value={-1}>{"NULL"}</MenuItem>
                      {users.map(user =>
                        (user.role === "system-user" && user.email !== selectedUserId) ?
                          <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>
                          : ''
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                : ''
              }
              <Grid item md={3} sm={6} xs={12} className="labelResizeFont">
                <TextField
                  disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                  label={(user.role === "system-user") ? strings.lblMaxSessionCompany : (user.role === "admin") ? "Max Allow Session" : strings.lblMaxSessionIndividual}
                  value={(user.maxSession === "") ? null : user.maxSession}
                  error={(this.state.errorSubClient !== "") ? true : false}
                  helperText={this.state.errorSubClient}
                  type="number"
                  size="small"
                  InputProps={{
                    inputProps: {
                      min: 0, max: (user.role === "sub-system-user" && this.state.defaultUserData) ?
                        (this.state.defaultUserData.parentId === user.parentId && this.state.defaultUserData.role === "sub-system-user") ? this.state.defaultUserData.maxSession + this.state.maxSession
                          : (user.parentId) ? this.state.maxLimitSubClient : 999
                        : 999
                    }
                  }}
                  fullWidth={true}
                  onChange={this.handleMaxSessionCompanyChange}
                  variant={strings.txtOutlined}
                  required
                />
              </Grid>

              {((user.role === "system-user") && (loggedInUser.role !== "system-user")) ?
                <Grid item md={3} sm={6} xs={12} className="labelResizeFont">
                  <TextField
                    disabled={(selectedUserId && user.status === userStatus.inActive) ? true : false}
                    label={strings.lblMaxSessionIndividual}
                    value={(user.maxSessionIndividual === "") ? "1" : user.maxSessionIndividual}
                    error={(this.state.errorClient !== "") ? true : false}
                    helperText={this.state.errorClient}
                    type="number"
                    size="small"
                    InputProps={{
                      inputProps: {
                        min: 0, max: (user.role === "system-user" && this.state.defaultUserData) ?
                          (this.state.defaultUserData.role === "" || this.state.defaultUserData.role === "sub-system-user") ? user.maxSession
                            // : this.state.maxLimitClient
                            : user.maxSession
                          : 999
                      }
                    }}
                    fullWidth={true}
                    onChange={this.handleMaxSessionClientChange}
                    variant={strings.txtOutlined}
                    required
                  />
                </Grid>
                : ''
              }
              {((this.state.subClient || user.role === "sub-system-user" || (loggedInUser.role === "system-user") && (this.state.maxSession >= 0 || (user.maxSession !== "" && this.state.maxSession >= 0)))) ?
                ((user.parentId === null || user.parentId === "" || loggedInUser.role === "system-user")) ? '' :
                  < Grid item md={12} sm={12} xs={12}>
                    <Typography variant="subtitle2">Available session left:
                      {this.state.maxSession}
                    </Typography>
                  </Grid>
                : (user.role === "system-user" && selectedUserId) ?
                  < Grid item md={12} sm={12} xs={12}>
                    <Typography variant="h6">Info: Max available session (Company): {
                      (this.state.maxSession <= 0 && this.state.subClient) ? { max_company_session } :
                        ((user.parentId === "" || user.parentId === null) && user !== "") ? user.maxSession : users.find(usr => usr.id === user.parentId).maxSession
                    }
                    </Typography>
                    <Typography variant="subtitle2">Available session left:
                  {this.state.maxSession}
                    </Typography>
                  </Grid>
                  : ""
              }

              <div id="leftSession" data-val={left_session}></div>

              {(loggedInUser.role === "system-user" && !selectedUserId) ?
                < Grid item md={12} sm={12} xs={12}>
                  <Typography variant="h6">Info: Max available session (Company): {max_company_session}
                  </Typography>
                  <Typography variant="subtitle2">Available session left:
                  {left_session}
                  </Typography>
                </Grid>
                : null}

              {(user.role === "autoAdded" && selectedUserId) ?

                < Grid item md={12} sm={12} xs={12}>
                  <Typography variant="h6">Info: Max available session (Company): {max_company_session}
                  </Typography>
                  <Typography variant="subtitle2">Available session left:
                  {left_session}
                  </Typography>
                </Grid>
                : null}

              <Grid item xs={12}>
                <FormControl fullWidth={true} margin={strings.txtNormal}>
                  <InputLabel shrink={true} >{strings.lblStations}</InputLabel>
                  <br /><SelectedStationsChips />
                </FormControl>

                {(selectedUserId && user.status === userStatus.inActive) ? ''
                  : <Button variant={strings.btnRaised} color={strings.colorPrimary} onClick={toggleStationsDialog}>{strings.lblSelect}&nbsp;<OpenInBrowserIcon /></Button>
                }&nbsp;

              </Grid>
            </Grid>
            <br /><FormHelperText>{strings.lblAsteriskRequired}</FormHelperText><br />
            <Divider /><br />
            <Grid container>
              <Button
                variant={strings.btnRaised}
                disabled={isInAyncProcess}
                onClick={this.handleBack}
              >
                {strings.lblBack}
              </Button>
              <FlexOne />
              {selectedUserId && user.status === userStatus.active &&
                <Button
                  color={strings.colorPrimary}
                  variant={strings.btnRaised}
                  onClick={this.handleDeactivate}
                >
                  {strings.lblDeactivate}
                </Button>
              }&nbsp;
              {selectedUserId && user.status === userStatus.inActive &&
                <Button
                  color={strings.colorPrimary}
                  variant={strings.btnRaised}
                  onClick={this.handleActivate}
                >
                  {strings.lblActivate}
                </Button>
              }&nbsp;
               {(selectedUserId && user.status === userStatus.inActive) ? ''
                : <Button
                  color={strings.colorPrimary}
                  variant={strings.btnRaised}
                  disabled={!isValid || isInAyncProcess}
                  onClick={this.handleSave}
                >
                  {strings.lblSave}
                </Button>
              }&nbsp;
            </Grid>
          </FormContainer>
        </Paper>
        <ComfirmDialog
          title={user.name}
          message={strings.msgDeactivateConfirm}
          onCancel={toggleDeleteConfirm}
          onOK={this.handleConfirmDeactivate}
          btnCancelText={strings.lblCancel}
          btnOKText={strings.lblDeactivate}
          open={openDeleteConfirmation}
        />
        <StationListDialog open={openStationsDialog} onClose={toggleStationsDialog} />
      </Page >
    )
  }
}

const mapStateToProps = state => ({
  currentUser: usersReducer.getCurrentUser(state),
  selectedUserId: usersReducer.getSelectedUserId(state),
  users: usersReducer.getUsers(state),
  isSearching: usersReducer.getIsSearching(state),
  user: userScreenReducer.getUser(state),
  nameError: userScreenReducer.getNameError(state),
  passwordError: userScreenReducer.getPasswordError(state),
  mobileError: userScreenReducer.getMobileError(state),
  emailError: userScreenReducer.getEmailError(state),
  companyError: userScreenReducer.getCompanyError(state),
  maxSessionCompanyError: userScreenReducer.getMaxSessionCompany(state),
  maxSessionClientError: userScreenReducer.getMaxSessionClient(state),
  personas: personasReducer.getPersonas(state),
  isValid: userScreenReducer.getIsValid(state),
  isSavingUser: usersReducer.getIsSaving(state),
  isActivatingUser: usersReducer.getIsActivating(state),
  isDeactivatingUser: usersReducer.getIsDeactivating(state),
  snackBarMessage: userScreenReducer.getSnackBarMessage(state),
  isPersonaSaving: personasReducer.getIsSaving(state),
  openDeleteConfirmation: userScreenReducer.getOpenDeleteConfirmation(state),
  openStationsDialog: userScreenReducer.getOpenStationsDialog(state),
  openedSnackBar: userScreenReducer.getOpenedSnackBar(state),
  actionStatus: userScreenReducer.getActionStatus(state),
  stations: stationsReducer.getSelectedStations(state),
  loggedInUser: systemReducer.getLoggedInUser(state)
})

const mapActionsToProps = {
  ...userScreenActions,
  fetchAllPersonas: personasAction.fetchAll,
  removeStationFromSelections: stationsAction.removeStationFromSelections,
  clearStationSelections: stationsAction.clearStationSelections,
  createUser: usersAction.create,
  updateUser: usersAction.update,
  search: usersAction.search,

  subClientSearch: usersAction.subClientSearch,

  deactivateUser: usersAction.deactivate,
  activateUser: usersAction.activate,
  currentUser: usersAction.currentUser,
  createPersona: personasAction.create,
}

export default connect(mapStateToProps, mapActionsToProps)(
  withRouter(
    withStyles(styles)(UserScreen)
  )
);